import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-social-twitter',
  templateUrl: './social-twitter.component.html'
})
export class SocialTwitterComponent {
  @Input() badgeWrapperSize: string = '50px';
  @Input() badgeIconSize: string = '30px';
  @Input() badgeStyleClass: string;
}
